/**
 * @generated SignedSource<<d24f8e478899f66e842d2dc4d4d9e33b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type cardHeader_updateWorkItemAllFieldTypesActionRenderer$data = {
  readonly issueTypeField: {
    readonly issueType: {
      readonly avatar: {
        readonly small: string | null;
      } | null;
      readonly name: string;
    } | null;
  } | null;
  readonly key: string;
  readonly summaryField: {
    readonly text: string | null;
  } | null;
  readonly webUrl: AGG$URL | null;
  readonly " $fragmentType": "cardHeader_updateWorkItemAllFieldTypesActionRenderer";
};
export type cardHeader_updateWorkItemAllFieldTypesActionRenderer$key = {
  readonly " $data"?: cardHeader_updateWorkItemAllFieldTypesActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"cardHeader_updateWorkItemAllFieldTypesActionRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "cardHeader_updateWorkItemAllFieldTypesActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "concreteType": "JiraSingleLineTextField",
      "kind": "LinkedField",
      "name": "summaryField",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "text"
        }
      ]
    },
    {
      "concreteType": "JiraIssueTypeField",
      "kind": "LinkedField",
      "name": "issueTypeField",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueType",
          "kind": "LinkedField",
          "name": "issueType",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "name"
            },
            {
              "concreteType": "JiraAvatar",
              "kind": "LinkedField",
              "name": "avatar",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "small"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "webUrl"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "8d8b4a0dd0f004bf80742a321be87063";

export default node;
